/* eslint-disable react/jsx-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import {HashLink as Link } from "react-router-hash-link";
import MenuIcon from '@mui/icons-material/Menu';
import theme from "../../theme";
import { TextContent, TextP } from "./styles";

type Anchor = "left" | "right";

interface TiposdeFiltro {
  nome?: any;
  homeNaparece?: boolean;
  isDark?: boolean;
}

const SideBar: React.FC<TiposdeFiltro> = ({
  nome,
  homeNaparece,
  isDark,
}) => {
  const [state, setState] = React.useState({
    left: false,
    right: false,
  });

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

  const navbar = (anchor: "right") => (
    <Box
      sx={{ width: "auto" }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List sx={{
        width: "200px",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignContent: "center"
      }}>
        {nome.map((dados: any) => (
          <TextContent>
            <TextP nameColor={dados?.name}>
            <Link to={dados?.link}>
              {dados?.name}          
            </Link>
              
            </TextP>
          </TextContent>
        ))}
      </List>
    </Box>
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      {!homeNaparece && (
        <>
          <MenuIcon
            sx={{
              color: theme.palette.secondary.main,
              height: "40px",
              width: "40px",
              marginRight: "10px",
            }}
            onClick={toggleDrawer("right", true)}
          >
            Menu
          </MenuIcon>
          <Drawer
            anchor="right"
            open={state.right}
            onClose={toggleDrawer("right", false)}
          >
            {navbar("right")}
          </Drawer>
        </>
      )}
    </div>
  );
};

export default SideBar;
